<template>
    <div>
      <div class="row">
        <!--<div class="col-lg-3" v-if="dataImage"><img :src="settingImagePage" width="150px" height="150px"/></div>-->
        <div class="col-12">
          <div :class="{ 'offset-lg-2 col-lg-4': isCrop }">
            <button v-if="updateImageWithData" type="button" class="btn btn-outline-primary btn-block w-full" @click="openModal('upload')">
              <div  v-if="isCrop"><i class="far fa-upload"></i> อัพโหลดรูปจากเครื่อง</div>
              <div v-else>
                <strong>เพิ่มรูปภาพ <i class="far fa-plus"></i></strong>
              </div>
            </button>
          </div>
          <div class="col-lg-4 col-md-6">
            <button v-if="updateImageWithLink" type="button" class="btn btn-outline-info btn-block w-full" @click="openModal('link')"><i class="far fa-link"></i>
                อัพโหลดรูปจากลิงค์</button>
          </div>
        </div>
      </div>


      <b-modal v-bind:title="imgUpload.modal.title" ref="model" hide-footer v-model="imgUpload.modal.active" @ok="imgUpload.modal.active = false">
        <div v-if="imgUpload.modal.action=='link'">
          <div class="row">
            <div class="col-md-12">
                <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">URL</span>
                </div>
                <input type="text" class="form-control" v-model="data.imgUpload.image">
                </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <b-btn class="mt-3" variant="outline-primary" block @click="submitImage">ยืนยันการเปลี่ยนแปลง</b-btn>
            </div>
            <div class="col-lg-6">
              <b-btn class="mt-3" variant="outline-secondary" block @click="cancleImageLink">ยกเลิกการเปลี่ยนแปลง</b-btn>
            </div>
          </div>
        </div>

        <div v-if="imgUpload.modal.action=='upload'">
          <div v-if="imgUpload.img.upload.active==false">
            <div class="custom-file">
              <input type="file" name="image" accept="image/*" class="custom-file-input" @change="setImage" />
              <label class="custom-file-label" for="customFile">Choose file</label>
            </div>
            <div v-if="imgUpload.img.view.active && isCrop">
              <br />
              <div style="width: 100%; height:68.5%; border: 1px solid gray; display: inline-block;">
              <vue-cropper ref='cropper' :src="imgUpload.img.view.src" :guides="true" :view-mode="2" drag-mode="crop"
                  :initialAspectRatio="100/68.5" :aspectRatio="100/68.5" :auto-crop-area="0.5" :min-container-width="100"
                  :min-container-height="68.5" :background="true" :rotatable="true" alt="zeedoc-img-imgUpload" :img-style="{ 'width': '100%', 'height': '68.5%' }">
              </vue-cropper>
              </div>
              <div>
              <div v-if="imgUpload.img.crop.active">
                  <hr>
                  <label for="ccnumber">ภาพที่จะแสดงในบทความ <i class="far fa-image"></i></label>
                  <img :src="imgUpload.img.crop.src" style="width: 100%; height: 68.5%; border: 1px solid gray" alt="ตัวอย่างรูปที่จะนำเข้า" />
              </div>
              <br />
              </div>
            </div>
            <div v-else>
              <img :src="imgUpload.img.view.src" alt="" width="100%" height="100%" />
                  <br/>
                  <hr/>
            </div>
            <br />
            <div class="row" v-if="imgUpload.img.view.src != '' && isCrop">
              <div class="col-lg-4">
                <b-btn @click="cropImage" class="mt-3" variant="primary" block>เลือกตัดภาพนี้</b-btn>
              </div>
              <div class="col-lg-4">
                <b-btn @click="rotate" class="mt-3" variant="info" block>หมุนภาพ</b-btn>
              </div>
              <div class="col-lg-4">
                <b-btn @click="cancleImage" class="mt-3" variant="secondary" block>ยกเลิกภาพนี้</b-btn>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="offset-lg-3 col-lg-6">
                <b-btn class="mt-3" variant="outline-primary" block @click="submitImage">ยืนยันการเปลี่ยนแปลง</b-btn>
              </div>
            </div>
          </div>

          <div v-if="imgUpload.img.upload.active">
            <div class="loader-container-4tiles clearfix">
                <div class="square s9 rounded"></div>
                <div class="square s2 rounded"></div>
                <div class="square s1 rounded"></div>
                <div class="square s6 rounded"></div>
            </div>
          </div>

        </div>
      </b-modal>

      
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs'
import Helper from '@/shared/helper'

export default {
    name: 'uploadImage',
    props: ['showIcon', 'updateImageWithLink', 'updateImageWithData', 'isCrop', 'dataImage', 'isInput'],
    components: {
        VueCropper
    },
    mixins: [Helper],
    data() {
        return  {
            imgUpload: {
                id: parseInt(this.$route.params.id),
                languages: {
                    data: []
                },
                categories: {
                    options: [],
                    selected: []
                },
                img: {
                    upload: {
                    active: false
                    },
                    view: {
                    src: '',
                    active: false
                    },
                    crop: {
                    src: '',
                    active: false
                    }
                },
                modal: {
                    title: '',
                    action: '',
                    active: false
                },
            },
                data: {
                    page: 0,
                    per_page: 0,
                    imgUpload: {
                        title: '',
                        image: '',
                        content: '',
                        lang: '',
                        categories: []
                    }
            },
            settingImagePage: ''
        }
    },
    mounted() {
        this.settingImagePage = this.dataImage
    },
    methods: {
        openModal(action) {
            this.imgUpload.modal.action = action
            if (action == 'upload') {
            this.imgUpload.modal.title = 'อัพโหลดรูปจากเครื่อง'
            this.imgUpload.modal.active = true
            } else if (action == 'link') {
            this.imgUpload.modal.title = 'อัพโหลดรูปจากลิงค์'
            this.imgUpload.modal.active = true
            }
        },
        setImage(e) {
            const file = e.target.files[0]
            this.imgUpload.img.view.active = true
            if (!file.type.includes('image/')) {
            alert('Please select an image file')
            return
            }
            if (typeof FileReader === 'function') {
            const reader = new FileReader();
            reader.onload = (event) => {
                this.imgUpload.img.view.src = event.target.result
                if(this.isCrop) {
                    this.$refs.cropper.replace(event.target.result)
                }
            }
            reader.readAsDataURL(file)
            } else {
            alert('Sorry, FileReader API not supported')
            }
        },
        async submitImage() {
            this.$refs.model.hide()
            const imgInput = this.isCrop ? this.imgUpload.img.crop.src : this.imgUpload.img.view.src
            if (imgInput) {
            this.imgUpload.img.upload.active = true

            try {
                const cdnUrl = await this.uploadImageDataUrl(imgInput, 'image.jpg')
                this.imgUpload.img.upload.active = false
                this.data.imgUpload.image = cdnUrl
                this.settingImagePage = cdnUrl
                if(this.isCrop) {
                    this.$emit('upload', this.data.imgUpload.image)
                } else {
                    const data = {
                        image: cdnUrl,
                    }
                    this.$emit('upload', data)
                    this.imgUpload.img.view.src = ''
                }
            } catch (error) {
                console.error(error)
                this.imgUpload.img.upload.active = false
                alert('คุณใส่ชนิดหรือรูปแบบของรูปภาพไม่ถูกต้อง!');
            }
            } else {
            this.imgUpload.img.upload.active = false
            }
      },
    cropImage() {
        this.imgUpload.img.crop.active = true
        this.imgUpload.img.crop.src = this.$refs.cropper.getCroppedCanvas().toDataURL('image/jpeg')
      },
      cancleImage() {
        this.imgUpload.img.crop.active = false
        this.imgUpload.img.crop.src = ''
        this.data.imgUpload.image = ''
      },
      cancleImageLink() {
        this.imgUpload.img.crop.active = false
        this.imgUpload.img.crop.src = ''
        this.data.imgUpload.image = ''
        this.imgUpload.modal.action = false
      },
       rotate() {
        this.$refs.cropper.rotate(90)
      },
    }
}
</script>

<style>

</style>
